var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.7185C16.7722 18.2501 14.1404 20 11.0919 20C10.1234 20 9.19693 19.8234 8.34418 19.5011C8.18827 19.4422 8.11031 19.4128 8.04832 19.3988C7.98735 19.385 7.94321 19.3792 7.88068 19.3769C7.81711 19.3745 7.74736 19.3815 7.60787 19.3957L3.00163 19.8627C2.56246 19.9072 2.34288 19.9295 2.21335 19.852C2.10054 19.7845 2.02369 19.6717 2.00324 19.5437C1.97976 19.3967 2.08468 19.2062 2.29454 18.8252L3.76578 16.1542C3.88694 15.9343 3.94752 15.8243 3.97496 15.7185C4.00206 15.6141 4.00861 15.5388 3.99994 15.4313C3.99117 15.3226 3.94251 15.181 3.84518 14.8978C3.58656 14.1452 3.44638 13.3392 3.44638 12.5011C3.44638 9.72158 4.98818 7.29526 7.2787 6",
    stroke: "#000D26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 4.5013V8.0013L18.3334 9.16797M21.8334 8.0013C21.8334 11.223 19.2217 13.8346 16.0001 13.8346C12.7784 13.8346 10.1667 11.223 10.1667 8.0013C10.1667 4.77964 12.7784 2.16797 16.0001 2.16797C19.2217 2.16797 21.8334 4.77964 21.8334 8.0013Z",
    stroke: "#000D26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatHistory);
export default __webpack_public_path__ + "static/media/chat-history.dc8a5e73092b17e1a017f923a7ae0e11.svg";
export { ForwardRef as ReactComponent };